<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import { useRouter,useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const goHref = () => {
  window.open(process.env.VUE_APP_API_LOGIN_URL, "_blank", "noopener,noreferrer");
};

const goRouter = (url) => {
  router.push(url);
};

const isShow = ref(true);

watch(
  () => route.path,
  (newPath, oldPath) => {
    if(newPath == '/integration'){
      isShow.value = false;
    }else{
      isShow.value = true;
    }
  },
  {
    immediate: true,
  }
);
onMounted(() => {});
</script>

<template>
  <div v-if="isShow" class="foot_img">
    <img src="@/assets/image/foot/footer_img.png" alt="" />
    <div class="foot_img_text">
      <span data-aos="fade-up">{{ $t('foot.hometext') }}</span>
      <button @click="goHref" data-aos="fade-up">{{ $t('foot.subtext') }}</button>
    </div>
  </div>
  <div class="foot">
    <div class="foot_item_l">
      <div class="foot_item_l_top">
        <div class="foot_icon">
          <img class="foot_icon_logo" src="@/assets/logo-dark.png" alt="" />
          <span class="foot_icon_text">{{ $t('logoText') }}</span>
        </div>
        <div class="foot_text">
          <div>{{ $t('foot.maintext') }}</div>
          <div>{{ $t('foot.maintext2') }}</div>
          <div>{{ $t('foot.maintext3') }}</div>
        </div>
        <div class="foot_icon_list">
          <img class="foot_icon_item" src="@/assets/image/foot/foot_icon.png" alt="" />
          <img class="foot_icon_item" src="@/assets/image/foot/foot_icon2.png" alt="" />
          <img class="foot_icon_item" src="@/assets/image/foot/foot_icon3.png" alt="" />
          <img class="foot_icon_item" src="@/assets/image/foot/foot_icon4.png" alt="" />
          <img class="foot_icon_item" src="@/assets/image/foot/foot_icon5.png" alt="" />
        </div>
      </div>
      <div class="foot_item_l_bottom">
        <div class="foot_copyright">
          <!-- <div>广州标品软件有限公司</div> -->
          <!-- <div>©Copyright © Wild Pony Pte. Ltd. All rights reserved</div> -->
          <!-- <div>粤 ICP 备20046039号</div> -->
        </div>
      </div>
    </div>
    <div class="foot_item_r">
      <div class="foot_r_item">
        <span>{{ $t('foot.mainclass') }}</span>
        <span @click="goRouter('/products/omnichannel')">{{ $t('foot.chat') }}</span>
        <span @click="goRouter('/products/automation')">{{ $t('foot.auto') }}</span>
        <span @click="goRouter('/products/team')">{{ $t('foot.teamwork') }}</span>
        <span @click="goRouter('/products/crm')">{{ $t('foot.relationship') }}</span>
        <span @click="goRouter('/products/analytics')">{{ $t('foot.date') }}</span>
        <span @click="goRouter('/products/translate')">{{ $t('foot.trans') }}</span>
      </div>
      <div class="foot_r_item">
        <span>{{ $t('foot.secclass') }}</span>
        <span>{{$t('foot.widget')}}</span>
        <span>Facebook Messenger</span>
        <span>Instagram</span>
        <span>WhatsApp</span>
        <span>{{ $t('foot.wabusiness') }}</span>
        <span>Telegram</span>
        <span>LINE</span>
        <span>TikTok</span>
      </div>
      <div class="foot_r_item">
        <span>{{ $t('foot.thirdclass') }}</span>
        <span>{{ $t('foot.fist') }}</span>
        <span>{{ $t('foot.fri') }}</span>
        <!-- <span @click="goRouter('/agreement')">{{ $t('foot.tos') }}</span> -->
        <a href="https://xmbgt1dev.top/agreement">{{ $t('foot.tos') }}</a>
        <span>{{ $t('foot.ubn') }}</span>
        <!-- <span @click="goRouter('/policy')">{{ $t('foot.pp') }}</span> -->
        <a href="https://xmbgt1dev.top/policy">{{ $t('foot.pp') }}</a>
        <span>{{ $t('foot.ara') }}</span>
        <span>{{ $t('foot.sdkpp') }}</span>
        <span>{{ $t('foot.sdkccg') }}</span>
      </div>
      <div class="foot_r_item">
        <span>{{ $t('foot.fourclass') }}</span>
        <span @click="goRouter('/manual')">{{ $t('foot.help') }}</span>
        <span>{{ $t('foot.blogtext') }}</span>
        <span>{{ $t('foot.plantext') }}</span>
      </div>
      <div class="foot_r_item">
        <span>{{ $t('foot.fiveclass') }}</span>
        <span @click="goRouter('/solution/Messenger')">Facebook Messenger</span>
        <span @click="goRouter('/solution/OwnedChannel')">{{ $t('foot.pdcs') }}</span>
      </div>
      <div class="foot_r_item">
        <span>{{ $t('foot.sixclass') }}</span>
        <span>{{ $t('foot.sug') }}service@Wild Pony.com</span>
        <span>{{ $t('foot.cooperation') }}service@Wild Pony.com</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.foot_img {
  position: relative;
  width: 100%;
  img {
    width: 100%;
  }
  .foot_img_text{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 8%;
    transform: translate(0%, -50%);
    span{
      width: 60%;
      font-size: 40px;
      font-weight: bold;
      color: #000;
    }
    button{
      width: 172px;
      height: 60px;
      background: #000;
      color: #fff;
      font-size: 18px;
      border-radius: 50px;
      margin-top: 30px;
    }
    button:hover{
      opacity: 0.8;
    }
  }
}
.foot {
  width: 100%;
  background: #fff;
  color: #00080ced;
  padding: 8%;
  cursor: default;
  display: flex;
  justify-content: space-between;
  .foot_item_l {
    width: 300px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .foot_item_l_top {
      .foot_icon {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .foot_icon_logo{
          width: 50px;
        }
        .foot_icon_text{
          margin-left: 10px;
          font-size: 24px;
          color: #003897;
          font-weight: bold;
        }
      }
      .foot_text {
        font-size: 18px;
        font-weight: 500;
      }
      .foot_icon_list {
        padding: 40px 0 80px;
        display: flex;
        justify-content: space-between;
        .foot_icon_item {
          width: 24px;
          height: 24px;
        }
      }
    }
    .foot_item_l_bottom {
      .foot_copyright {
        font-size: 14px;
        color: #000e18b2;
      }
    }
  }
  .foot_item_r {
    width: 70%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .foot_r_item {
      width: 30%;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      margin-bottom: 50px;
      span {
        color: #000000;
        padding-bottom: 10px;
      }
      a{
        color: #000000;
        padding-bottom: 10px;
      }
      span:nth-child(1) {
        color: #000e18b2;
      }
      span:last-child {
        padding-bottom: 0;
      }
    }
    .foot_r_item:nth-child(n + 3) {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .foot {
    flex-direction: column-reverse;
    .foot_item_r {
      width: 100%;
      flex-direction: column;
      .foot_r_item {
        width: 100%;
        margin-bottom: 20px;
      }
      .foot_r_item:nth-child(n + 3) {
        margin-bottom: 20px;
      }
    }
  }
  .foot_icon_list {
    padding: 20px 0px !important;
  }
  .foot_copyright {
    margin-bottom: 0px !important;
  }

  .foot_img_text{
    span{
      width: 100% !important;
      font-size: 18px !important;
    }
    button{
      width: 100px !important;
      height: 35px !important;
      font-size: 10px !important;
      margin-top: 10px !important;
    }
  }
}
</style>
